/**
 * Dashboard for VoxPop Review created by karora on 25/05/17.
 */
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TimerObservable } from 'rxjs/observable/TimerObservable';

import { ProfileService } from './services/profile.service';

@Component({
  moduleId: module.id,
  selector: 'voxpop-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})

export class DashboardComponent implements OnInit {
  reviewOK = false;
  testValue: boolean = false;
  private timer: Subscription;

  constructor(
    // private voxPopService: VoxPopService,
    // private router: Router,
  ) {
  }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;
    this.reviewOK = ProfileService.CanReview();
    document.getElementById("title").innerText = 'Dashboard';
    let timer = TimerObservable.create(1000, 300000);
    this.timer = timer.subscribe(t => {
      this.reviewOK = ProfileService.CanReview();
    });
  }
}
